import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, LayoutGrid, Pin } from 'lucide-react';
import { useAuthStore } from '../store/authStore';
import { APPS } from '../utils/cloudStorage';
import useToolPreferences from '../apps-explorer/useToolPreferences';
import './toolLauncher.css';

const toolKeys = Object.keys(APPS).filter(key => !APPS[key].hidden);

export function availableToolKeys(user, keys, now = Date.now()) {
  return keys.filter(key => {
    const app = APPS[key];
    if (!app || app.hidden) return false;
    if (!app.premium) return true;
    const access = user?.apps?.[key] || user?.appsAccess?.[key];
    return access?.enabled && new Date(access.expiresAt).getTime() > now;
  });
}

function ToolLinks({ user, t }) {
  const preferences = useToolPreferences(toolKeys);
  const refreshApps = useAuthStore(state => state.refreshApps);
  const keys = availableToolKeys(user, preferences.keys);

  useEffect(() => { refreshApps(); }, [refreshApps]);

  return (
    <section className="landing-tools" aria-labelledby="landing-tools-title">
      <div className="wrap landing-tools-inner">
        <div className="landing-tools-heading">
          <h2 id="landing-tools-title"><LayoutGrid size={16} aria-hidden="true" />{t('Mis herramientas')}</h2>
          <Link to="/apps">{t('Ver todas y organizar favoritas')} <ArrowUpRight size={14} aria-hidden="true" /></Link>
        </div>
        <ul className="landing-tools-list" aria-label={t('Mis herramientas')}>
          {keys.map(key => {
            const app = APPS[key];
            return <li key={key}>
              <Link to={app.link}>
                <span className="landing-tools-icon" aria-hidden="true">{app.title.split(' ').slice(0, 2).map(word => word[0]).join('')}</span>
                <span className="landing-tools-name">{app.title}</span>
                {preferences.prefs.pinned.includes(key) && <Pin size={12} aria-label={t('Favorita')} />}
                <ArrowUpRight className="landing-tools-arrow" size={14} aria-hidden="true" />
              </Link>
            </li>;
          })}
        </ul>
        {preferences.error && <p className="landing-tools-status" role="status">{t('No pudimos cargar tus favoritas. Puedes abrir tus herramientas igualmente.')}</p>}
      </div>
    </section>
  );
}

export default function ToolLauncher({ t }) {
  const user = useAuthStore(state => state.user);
  const isAuthenticated = useAuthStore(state => state.isAuthenticated);
  return isAuthenticated && user ? <ToolLinks key={user._id} user={user} t={t} /> : null;
}
